/*
 * Hide specific Judge.me transparency badges ("Review collected from another
 * provider", "Review collected from a store visitor") in the revamped
 * Judge.me widget (jm-* classes, client-rendered). The wrapper class
 * .jm-transparency-badge-list is shared by every transparency-badge type
 * (store invite, store visitor, another provider, verified provider, etc.),
 * so we match on the exact visible text rather than the class alone, to
 * avoid hiding any other badge type. This only toggles display; it does not
 * remove or alter the underlying review data.
 */
(function () {
  var TARGET_TEXTS = [
    'Review collected from another provider',
    'Review collected from a store visitor'
  ];

  function hideMatchingBadges(root) {
    var nodes = (root || document).querySelectorAll('.jm-transparency-badge-list .jm-text');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var text = el.textContent && el.textContent.trim();
      if (text && TARGET_TEXTS.indexOf(text) !== -1) {
        el.style.display = 'none';
      }
    }
  }

  hideMatchingBadges();

  var observer = new MutationObserver(function () {
    hideMatchingBadges();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
